var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33427 0.749069C5.54382 0.104151 6.45621 0.104152 6.66575 0.749069L7.41445 3.05333C7.50816 3.34174 7.77693 3.53701 8.08019 3.53701H10.503C11.1811 3.53701 11.4631 4.40475 10.9145 4.80333L8.95436 6.22744C8.70902 6.40569 8.60636 6.72164 8.70007 7.01006L9.44877 9.31432C9.65832 9.95924 8.92018 10.4955 8.37158 10.0969L6.41146 8.67283C6.16612 8.49458 5.8339 8.49458 5.58856 8.67283L3.62844 10.0969C3.07984 10.4955 2.34171 9.95924 2.55126 9.31432L3.29995 7.01006C3.39367 6.72164 3.29101 6.40569 3.04566 6.22744L1.08555 4.80333C0.536947 4.40475 0.81889 3.53701 1.497 3.53701H3.91984C4.22309 3.53701 4.49186 3.34174 4.58558 3.05333L5.33427 0.749069Z",
    fill: "#6FC04D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star_icon.e0e74fbffb9e377c615a64f83295e8cc.svg";
export { ForwardRef as ReactComponent };